<script lang="ts" module>
  import { useDynamicConfig } from '@/ui/state/use-core-state.svelte';
  import { useActiveText } from '@/utils/teo-context';
  import { useActiveTextUIViewValue } from '@/utils/teo-context/teo-atoms/text';
  import { useConfig } from '@/utils/teo-context/teo-atoms/use-config.svelte';

  import AnalysisConfigPanel from './AnalysisConfigPanel.svelte';
  import GeneratorConfigPanel from './GeneratorConfigPanel.svelte';
</script>

<script lang="ts">
  let activeText = useActiveText();
  let dynamicConfig = useDynamicConfig();

  let [config, { setConfig }] = useConfig();
  let view = useActiveTextUIViewValue();
</script>

{#if activeText.current}
  {#key activeText.current}
    {#if view.current !== 'text-generator'}
      {#key $dynamicConfig.textConfigOptions}
        <AnalysisConfigPanel
          setup={$dynamicConfig.textConfigOptions}
          values={config.current ?? {}}
          onChange={setConfig}
        />
      {/key}
    {:else}
      <GeneratorConfigPanel></GeneratorConfigPanel>
    {/if}
  {/key}
{/if}
